module.exports = __webpack_public_path__ + "img/second-1.72c2e705.webp";